$('body').on('submit', '.contact form', function () {
    console.log('contact');
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: "_token", value: $('meta[name="csrf-token"]').attr("content") };

    var error = false;

    $('.contact').find('.required').each(function () {
        var input = $(this);

        if (input.attr('type') === 'radio') {
            if (!$('.contact').find('input[name="' + input.attr('name') + '"]:checked').length) {
                error = true;
            }
        }

        if (input.attr('type') === 'checkbox') {
            if (!input.prop('checked')) {
                error = true;
            }
        }

        if (input.val() === '') {
            error = true;
        }
    });

    if (error) {
        $('.contact .message').show().html('Please fill out all required fields');
        return false;
    }

    $('.contact input').prop('disabled', true);
    $('.contact .message').hide();
    loading('Processing...');
    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: fields,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();
            $('.contact input').prop('disabled', false);
            if (data.success) {
                $('.contact form')[0].reset();
            }

            $('.contact .message').show().html(data.message);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});